<script setup>
import { ref, computed, watch, getCurrentInstance } from 'vue';

const { proxy } = getCurrentInstance();

const { $bus, $constants, $stores } = proxy;
const currentPage = ref(0);
const pageSize = 10; // adapte si nécessaire

const state = computed(() => $stores.customers?.state?.list_all);

const totalPages = computed(() => {
  const total = state.value?.total || 0;
  return Math.ceil(total / pageSize);
});

function changePage(page) {
  if (page < 0) return;
  if (page >= totalPages.value) return;

  currentPage.value = page;

  $bus.emit($constants.EVENTS.CUSTOMERS.LIST_ALL.REFRESH, { page });
}

/**
 * Optionnel :
 * reset la page quand on relance un refresh global
 */
watch(
  () => state.value?.resetPagination,
  (val) => {
    if (val) {
      currentPage.value = 0;
    }
  }
);
</script>

<template>
  <PageLayout>
    <template #headerTitle> Clients </template>
    <VBusHelper :emitOnMounted="$constants.EVENTS.CUSTOMERS.LIST_ALL.REFRESH" />
    <CustomersListError
      @refresh="() => $bus.emit($constants.EVENTS.CUSTOMERS.LIST_ALL.REFRESH)"
      v-if="$stores.customers?.state?.list_all?.error"
    >
      <template #errorDescription>
        {{ $stores.customers?.state?.list_all?.error }}
      </template>
    </CustomersListError>
    <div
      v-else-if="$stores.customers?.state?.list_all?.list.length"
      class="space-y-4"
    >
      <CustomerItem
        @click="
          () => {
            $router.push(`/customer/detail/?id=${customer.id}`);
          }
        "
        v-for="customer in $stores.customers?.state?.list_all?.list"
        :item="customer"
      />

      <div class="px-6 py-3 bg-gray-50 flex justify-between items-center">
        <span class="text-sm text-gray-700"
          >Page {{ currentPage + 1 }} of {{ totalPages }}</span
        >
        <div class="space-x-2">
          <button
            @click="changePage(currentPage - 1)"
            class="px-3 py-1 bg-purple-100 text-purple-700 rounded hover:bg-purple-200"
          >
            &lt;
          </button>
          <button
            @click="changePage(currentPage + 1)"
            class="px-3 py-1 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
          >
            &gt;
          </button>
        </div>
      </div>
    </div>
    <div
      v-else-if="$stores.customers?.state?.list_all?.loading"
      class="space-y-4 shimmerContainer"
    >
      <CustomerItem v-for="customer in 9" :item="customer" />
    </div>
    <!-- <EmptyTransactions
      @refresh="
        () => $bus.emit($constants.EVENTS.CUSTOMERS.LIST_ALL.REFRESH)
      "
      v-else
    /> -->
  </PageLayout>
</template>
